import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Dashboard from "./Pages/dashboard";
import ResetPassword from "./Pages/ResetPassword";
import MemberManagement from "./Pages/memberManagement";
import StaffManagement from "./Pages/staffManagement";
import Notifications from "./Pages/notifications";
import Subscriptions from "./Pages/subscriptions";
import Settings from "./Pages/settings";
import Location from "./Pages/location";
import ActionLog from "./Pages/ActionLog";
import InputOTP from "./components/otp/inputOtp";
import RequestOTP from "./components/otp/requestOtp";
import { MemberProvider } from "./context/MemberContext";
import QrCode from "./Pages/qrCode";
import ProtectedRoute from "./route/ProtectedRoute";
import RoleProtectedRoute from "./route/RoleProtectedRoute";
import ViewMember from "./Pages/ViewMember";
import Login from "./Pages/login";
import NotificationProvider from "./components/NotificationProvider";
import { setupDefaultAxiosInterceptors } from "./utils/axiosConfig";
import useAuth from "./hooks/useAuth";
import { useEffect } from "react";

function App() {
  const authManager = useAuth();

  useEffect(() => {
    setupDefaultAxiosInterceptors();
  }, []);

  return (
    <Router>
      <MemberProvider>
        <div className="App">
          <ToastContainer />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/request-otp" element={<RequestOTP />} />
            <Route path="/input-otp" element={<InputOTP />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Navigate to="/login" />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <NotificationProvider>
                    <Dashboard />
                  </NotificationProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/member-management"
              element={
                <ProtectedRoute>
                  <NotificationProvider>
                    <MemberManagement />
                  </NotificationProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/staff-management"
              element={
                <RoleProtectedRoute allowedRoles={[3, 4]}>
                  <NotificationProvider>
                    <StaffManagement />
                  </NotificationProvider>
                </RoleProtectedRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute>
                  <NotificationProvider>
                    <Notifications />
                  </NotificationProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/location"
              element={
                <RoleProtectedRoute allowedRoles={[3]}>
                  <NotificationProvider>
                    <Location />
                  </NotificationProvider>
                </RoleProtectedRoute>
              }
            />
            <Route
              path="/qr-code"
              element={
                <ProtectedRoute>
                  <NotificationProvider>
                    <QrCode />
                  </NotificationProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription"
              element={
                <ProtectedRoute>
                  <NotificationProvider>
                    <Subscriptions />
                  </NotificationProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/action-log"
              element={
                <RoleProtectedRoute allowedRoles={[3]}>
                  <NotificationProvider>
                    <ActionLog />
                  </NotificationProvider>
                </RoleProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <RoleProtectedRoute allowedRoles={[3, 4]}>
                  <NotificationProvider>
                    <Settings />
                  </NotificationProvider>
                </RoleProtectedRoute>
              }
            />
            <Route
              path="/view-member"
              element={
                <ProtectedRoute>
                  <NotificationProvider>
                    <ViewMember />
                  </NotificationProvider>
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </MemberProvider>
    </Router>
  );
}

export default App;
